import React, { FC } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import EmailWorkflow from 'Src/feature/provision/EmailWorkflow';
import ProvisionerLanding from 'Src/feature/provision/ProvisionerLanding';
import TokenWorkflow from 'Src/feature/provision/TokenWorkflow';

const ProvisionRouter: FC = () => (
  <Routes>
    <Route path="provision/*">
      <Route index element={<ProvisionerLanding />} />
      <Route path="workflow">
        <Route path="email" element={<EmailWorkflow />} />
        <Route path="token" element={<TokenWorkflow />} />
      </Route>
    </Route>
    <Route path="*" element={<Navigate to="/provision" replace />} />
  </Routes>
);

export default ProvisionRouter;
